import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TerritoryTable from "./territoryTable";
import ParentTerritory from "./parentTerritory";
import AddRuleModal from "./addruleModal";
import Select from "react-select";
import { FaPencil } from "react-icons/fa6";
import { MdOutlineDelete } from "react-icons/md";

const CreateTerritory = ({ setIsShowNewCreationUI, handleSubmit,
    createTerritoryFrom, isCreate, selectedTerritoryToEdit, handleUpdate
}) => {
    let allUsers = useSelector((state) => state?.user)?.allUserData;
    let territoryList = useSelector((state) => state?.territory)?.territoryList;
    let [isTerritoryTableOpen, setIsTerritoryTableOpen] = useState(false);
    let [isParentTerritoryModalOpen, setIsParentTerritoryModalOpen] = useState(false);
    let [isAddRuleModalOpen, setIsAddRuleModalOpen] = useState(false);
    let [userData, setUserData] = useState([])
    let [isCreateRule, setIsCreateRule] = useState(true)
    let [showRuleList, setShowRuleList] = useState(false)
    let [territoryData, setTerritoryData] = useState({
        territory_name: '',
        description: '',
        territory_manager: {},
        parent_territory: {},
        assign_users: [],
        permission_type: 'read-only',
        account_rule: []
    })

    useEffect(() => {
        if (!isCreate && selectedTerritoryToEdit) {
            setTerritoryData((prev) => ({
                ...prev,
                territory_name: selectedTerritoryToEdit.territory_name,
                description: selectedTerritoryToEdit.description,
                territory_manager: selectedTerritoryToEdit.territory_manager,
                parent_territory: selectedTerritoryToEdit.parent_territory,
                assign_users: selectedTerritoryToEdit.assign_users,
                permission_type: selectedTerritoryToEdit.permission_type,
                account_rule: selectedTerritoryToEdit.account_rule
            }));
        }
    }, [isCreate])

    useEffect(() => {
        if(territoryList && territoryList.length > 0) {
        if (createTerritoryFrom === 'null') {
            const selectedTerritory = territoryList.find(obj => obj.parent_territory === null);
            if (selectedTerritory) {
                setTerritoryData((prev) => ({
                    ...prev,
                    parent_territory: {
                        name: selectedTerritory?.territory_name,
                        id: selectedTerritory?._id
                    }
                }));
            }
        } else {
            const selectedTerritory = territoryList.find(obj => obj._id === createTerritoryFrom);
            if (selectedTerritory) {
                setTerritoryData((prev) => ({
                    ...prev,
                    parent_territory: {
                        name: selectedTerritory?.territory_name,
                        id: selectedTerritory?._id
                    }
                }));
            }
            }
        }
    }, [createTerritoryFrom])

    useEffect(() => {
        if (allUsers?.length) {
            setUserData(allUsers.map(option => option._id && {
                label: option.firstName + option.lastName,
                value: option._id
            }));
        }
    }, [allUsers])

    const formHandler = (e) => {
        try {
            const { name, value } = e?.target;
            setTerritoryData((prev) => ({
                ...prev,
                [name]: value
            }));
        } catch (err) {
            throw err;
        }
    };

    const assignUserHandler = (item) => {
        setTerritoryData((prev) => ({
            ...prev,
            assign_users: item
        }));
    }

    const handleSelectManager = (value) => {
        setTerritoryData((prev) => ({
            ...prev,
            territory_manager: {
                name: `${value.firstName} ${value.lastName}`,
                id: value._id
            }
        }));
    }

    const handleParentTerritory = (value) => {
        setTerritoryData((prev) => ({
            ...prev,
            parent_territory: {
                name: value?.territory_name,
                id: value?._id
            }
        }));
        setIsParentTerritoryModalOpen(false)
    }

    const handleOpenTerritoryTable = () => {
        setIsTerritoryTableOpen(true);
    };

    const handleCloseTerritoryTable = () => {
        setIsTerritoryTableOpen(false);
    };

    const handleOpenAddRuleModal = () => {
        setIsAddRuleModalOpen(true);
        setIsCreateRule(true)
    };

    const handleCloseAddRuleModal = () => {
        setIsAddRuleModalOpen(false);
    }

    const handleRule = (rule, data) => {
        setTerritoryData((prev) => ({
            ...prev,
            account_rule: rule.conditions
        }));
    }

    const handleDeleteRule = () => {
        setShowRuleList(false)
        setTerritoryData((prev) => ({
            ...prev,
            account_rule: []
        }));
    }

    useEffect(() => {
        if (territoryData?.account_rule?.length) {
            setShowRuleList(true)
        }
    }, [territoryData?.account_rule])

    const getCriteria = (length) => {
        if (length === 0) return '';
        if (length === 1) return '1';
        if (length === 2) return '(1 and 2)';

        const previous = getCriteria(length - 1);
        return `(${previous} and ${length})`;
    };

    return (
        <>
            <div className="roles">
                <div className="pt-4">
                    <h5 className="fw-semibold">
                        Create New Territory
                    </h5>
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="row mt-3">
                                <div className="col-4">
                                    <label>Territory Name</label>
                                </div>
                                <div className="col-5">
                                    <input type="text" className="form-control" placeholder="Enter a value"
                                        name="territory_name" required
                                        value={territoryData?.territory_name} onChange={formHandler} />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-4">
                                    <label>Description</label>
                                </div>
                                <div className="col-5">
                                    <textarea className="form-control" placeholder="Enter your description"
                                        name="description"
                                        value={territoryData?.description} onChange={formHandler} ></textarea>
                                </div>
                            </div>
                            {(isCreate || (!isCreate && selectedTerritoryToEdit.parent_territory)) &&
                                <>
                                    <div className="row mt-3">
                                        <div className="col-4">
                                            <label>Territory Manager</label>
                                        </div>
                                        <div className="col-5 input-control">
                                            <div className="input-group mt-0">
                                                {/* <select className="form-select" value={territoryData?.description}>
                                                    <option>Assign Manager</option>
                                                </select> */}
                                                <input className="form-control" readOnly value={territoryData?.territory_manager?.name}
                                                    placeholder="Territory Manager" />
                                                <span className="input-group-text fs-14 cursor-pointer" onClick={handleOpenTerritoryTable}><i className="fa-solid fa-user-plus"></i></span>
                                                {isTerritoryTableOpen && (
                                                    <TerritoryTable isOpen={isTerritoryTableOpen} onClose={handleCloseTerritoryTable} onUserSelect={handleSelectManager} allUsers={allUsers} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-4">
                                            <label>Parent Territory</label>
                                        </div>
                                        <div className="col-5 input-control">
                                            <div className="input-group mt-0">
                                                <input type="text" className="form-control bg-body-tertiary cursor-pointer" id="newUserRole" placeholder="Parent Territory"
                                                    value={territoryData?.parent_territory?.name} readOnly />
                                                <span className="input-group-text fs-14 cursor-pointer" onClick={() => setIsParentTerritoryModalOpen(true)}>
                                                    <i className="fa-solid fa-location-dot"></i>
                                                </span>
                                                {isParentTerritoryModalOpen &&
                                                    <ParentTerritory
                                                        isOpen={isParentTerritoryModalOpen}
                                                        onClose={() => setIsParentTerritoryModalOpen(false)}
                                                        handleSave={(v) => handleParentTerritory(v)}
                                                        territoryList={territoryList}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-4">
                                            <label>Assign Users</label>
                                        </div>
                                        <div className="col-5">
                                            <Select
                                                value={territoryData.assign_users}
                                                className="mb-3 me-2 col-12"
                                                options={userData}
                                                isMulti
                                                onChange={assignUserHandler}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-4">
                                            <label>Permissions</label>
                                        </div>
                                        <div className="col-5">
                                            <select className="form-select" name="permission_type" value={territoryData.permission_type} onChange={formHandler} >
                                                <option value="read-only">Read Only</option>
                                                <option value="read-write-delete">Read/Write/Delete</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-9">
                                            {!showRuleList ?
                                                <button className="btn btn-outline-primary btn-blue me-2" type="button"
                                                    onClick={handleOpenAddRuleModal}>Add Account Rule</button> :
                                                <div className="form-group card mb-2">
                                                    <h6>Territory Rules
                                                        <span className="float-end">
                                                            <FaPencil className="me-2" style={{ fontSize: '14px' }}
                                                                onClick={() => { setIsCreateRule(false); setIsAddRuleModalOpen(true) }}
                                                            />
                                                            <MdOutlineDelete style={{ fontSize: '16px' }} onClick={() => handleDeleteRule()} />
                                                        </span>
                                                    </h6>
                                                    <div>
                                                        {territoryData?.account_rule?.length && territoryData?.account_rule?.map((dta, index) =>
                                                            <div>
                                                                <span>{index + 1}. </span>
                                                                <span>{dta?.field?.split('#')?.[1]}</span>
                                                                <span style={{ color: '#20b8a8' }} className="ms-1 me-1">{dta?.condition?.split('#')?.[1]}</span>
                                                                <span>{dta?.value}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {territoryData?.account_rule?.length > 1 &&
                                                        <div>
                                                            <div className="col-auto d-flex align-items-center">
                                                                <span className="fw-medium">Criteria Pattern</span>
                                                                <i className="bi bi-question-circle text-primary ms-2" style={{ fontSize: '16px' }}></i>
                                                            </div>
                                                            <div className="col">
                                                                <span className="text-muted">{getCriteria(territoryData?.account_rule?.length)}</span>
                                                                {/* <button className="btn btn-link ms-2 text-primary p-0">Edit Pattern</button> */}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            <AddRuleModal isOpen={isAddRuleModalOpen} onClose={handleCloseAddRuleModal} handleRule={handleRule} isCreateRule={isCreateRule} territoryData={territoryData} />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div >
            <div className="form-footer rounded-bottom-0 position-absolute start-0 bottom-0 w-100 bg-white border-top pe-4 py-2 d-flex justify-content-end">
                <button className="btn btn-outline-primary btn-blue me-2" type="button"
                    onClick={() => setIsShowNewCreationUI(false)}>Cancel</button>
                {isCreate ?
                    <button className="btn btn-primary btn-blue" type="button" onClick={() => handleSubmit(territoryData)}>Submit</button> :
                    <button className="btn btn-primary btn-blue" type="button" onClick={() => handleUpdate(selectedTerritoryToEdit?._id, territoryData)}>Update</button>
                }
            </div>
        </>
    )
}
export default CreateTerritory;